export default "__VITE_ASSET__Df$S5kr3__"